/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlEntityPastebinOrderBy = {
    PastebinKey: 'pastebin_key',
    PastebinUrl: 'pastebin_url',
    PastebinMeta: 'pastebin_meta',
    PastebinHighlight: 'pastebin_highlight',
    Found: 'found',
    Created: 'created',
    Updated: 'updated'
} as const;
export type ControlEntityPastebinOrderBy = typeof ControlEntityPastebinOrderBy[keyof typeof ControlEntityPastebinOrderBy];


export function ControlEntityPastebinOrderByFromJSON(json: any): ControlEntityPastebinOrderBy {
    return ControlEntityPastebinOrderByFromJSONTyped(json, false);
}

export function ControlEntityPastebinOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityPastebinOrderBy {
    return json as ControlEntityPastebinOrderBy;
}

export function ControlEntityPastebinOrderByToJSON(value?: ControlEntityPastebinOrderBy | null): any {
    return value as any;
}

